/**
 * Register the global service worker for offline shell + push relay.
 * Fire-and-forget: never blocks rendering, no UI surface.
 *
 * Called once from src/index.js at app boot. Subsequent visits use the
 * already-installed SW; we just trigger an update check so a deploy lands
 * for the user on their *next* navigation (no force-reload).
 */
export function registerAppServiceWorker() {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    if (process.env.NODE_ENV !== "production") return; // skip the noisy SW lifecycle in dev

    // Wait for first paint to avoid contending for main thread.
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js")
            .then((reg) => { reg.update().catch(() => {}); })
            .catch(() => { /* silent — push.js will retry on opt-in */ });
    });
}
